import { ApplicationId, clientIdentification } from '@gjensidige/service-client-identification';

const applicationId = clientIdentification.getApplicationId();

export const CUSTOMER_SEGMENT = !applicationId || applicationId === ApplicationId.Internett ? 'privat' : 'bedrift';
